__turbopack_context__.v({
  "body": "nkF5vq_body",
  "description": "nkF5vq_description",
  "header": "nkF5vq_header",
  "root": "nkF5vq_root",
});
